"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Core = void 0;
const adapters_1 = require("../../adapters");
class Core {
    url;
    headers;
    constructor(url, headers) {
        this.url = url;
        this.headers = headers;
    }
    /**
     * List of available localization cultures
     
      * @returns List of available localization cultures
     */
    GetAvailableLocales(tokens) {
        const requestURL = `${this.url}/GetAvailableLocales/`;
        const authHeaders = (0, adapters_1.parseAuthenticationHeaders)(this.headers, tokens);
        return (0, adapters_1.request)(requestURL, true, "GET", authHeaders);
    }
    /**
     * Get the common settings used by the Bungie.Net environment.
     
      * @returns Get the common settings used by the Bungie.Net environment.
     */
    GetCommonSettings(tokens) {
        const requestURL = `${this.url}/Settings/`;
        const authHeaders = (0, adapters_1.parseAuthenticationHeaders)(this.headers, tokens);
        return (0, adapters_1.request)(requestURL, true, "GET", authHeaders);
    }
    /**
     * Get the user-specific system overrides that should be respected alongside common systems.
     
      * @returns Get the user-specific system overrides that should be respected alongside common systems.
     */
    GetUserSystemOverrides(tokens) {
        const requestURL = `${this.url}/UserSystemOverrides/`;
        const authHeaders = (0, adapters_1.parseAuthenticationHeaders)(this.headers, tokens);
        return (0, adapters_1.request)(requestURL, true, "GET", authHeaders);
    }
    /**
     * Gets any active global alert for display in the forum banners, help pages, etc. Usually used for DOC alerts.
     * @param includestreaming Determines whether Streaming Alerts are included in results
     * @returns Gets any active global alert for display in the forum banners, help pages, etc. Usually used for DOC alerts.
     */
    GetGlobalAlerts(queryString, tokens) {
        const requestURL = (0, adapters_1.formatQueryStrings)(`${this.url}/GlobalAlerts/`, queryString);
        const authHeaders = (0, adapters_1.parseAuthenticationHeaders)(this.headers, tokens);
        return (0, adapters_1.request)(requestURL, true, "GET", authHeaders);
    }
}
exports.Core = Core;
